/**
 * Vehicle insurance claim status values
 */
export enum VehicleInsuranceClaimStatusEnum {
	/**
	 * Vehicle insurance claim is pending
	 */
	PENDING = 'pending',
	/**
	 * Vehicle insurance claim is settled
	 */
	SETTLED = 'settled',
}
